import React from 'react';
import PropTypes from 'prop-types';
import CustomButton, {
  defaultButtonStyle,
} from 'components/common/CustomButton';
import routes from 'routes';
import { useNavigate, useParams } from 'react-router-dom';

const BackEventButton = ({
  meet,
  clubId,
  viewType,
  marginBottom = 15,
}) => {
  const navigate = useNavigate();
  const params = useParams();
  const resolvedViewType = viewType || params.viewType || 'event-view';
  return (
    <CustomButton
      onClick={() => {
        navigate(routes.admin.events.url(clubId, meet.meetID, resolvedViewType));
      }}
      style={{
        ...defaultButtonStyle,
        color: '#24282a',
        fontWeight: 600,
        textDecoration: 'underline',
        backgroundColor: 'transparent',
        height: 'unset',
        marginBottom: marginBottom,
        zIndex: 1,
      }}
    >
      {meet ? `Back to ${meet?.meetName}` : 'Go to event'}
    </CustomButton>
  );
};

BackEventButton.propTypes = {
  meet: PropTypes.object,
  clubId: PropTypes.string,
  viewType: PropTypes.string,
  marginBottom: PropTypes.number,
};

export default BackEventButton;
